<template>
  <div>
    <image-uploader
      :value="value.backgroundImage"
      label="Background Image URL"
      @input="update('backgroundImage', $event)"
    />
    <v-slider
      v-if="value.backgroundImage"
      :value="value.bgOpacity !== undefined ? value.bgOpacity : 85"
      label="Background Darken %"
      min="0"
      max="100"
      thumb-label
      dense
      @input="update('bgOpacity', $event)"
    ></v-slider>
    <v-select
      :value="value.variant"
      :items="['centered', 'split', 'gradient']"
      label="Style Variant"
      outlined
      dense
      @input="update('variant', $event)"
    />
    <ImageUploader
      v-if="value.variant === 'split'"
      :value="value.heroImage"
      label="Hero Image URL"
      @input="update('heroImage', $event)"
    />
    <v-text-field
      :value="value.headline"
      label="Headline"
      outlined
      dense
      @input="update('headline', $event)"
    />
    <v-textarea
      :value="value.subheadline"
      label="Subheadline"
      outlined
      dense
      rows="2"
      @input="update('subheadline', $event)"
    />
    <v-text-field
      :value="value.ctaText"
      label="Button Text"
      outlined
      dense
      @input="update('ctaText', $event)"
    />
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
  },
};
</script>
